<div class="tooltip">
  <mat-icon class="tooltip-icon" svgIcon="tooltip-i"></mat-icon>
  <div class="tooltip-card" [ngClass]="alignTooltip() === 'right' ? 'align-right' : ''">
    <div class="tooltip-title">
      <mat-icon class="tooltip-icon" svgIcon="tooltip-i"></mat-icon>
      <p class="tooltip-title-text">{{ infoTitle() }}</p>
    </div>
    <div class="tooltip-text">
      <p>
        {{ infoText() }}
      </p>
    </div>
  </div>
</div>
